















































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { DispensationMedicine } from '@/types/dispensation'
import { Medicine } from '@/types/medicine'
import { sanitize, nl2br } from '@/utils/string'

@Component({
  components: {
    Loading: () => import('@/components/common/loadings/Index.vue')
  }
})
export default class MedicineDetailsModal extends Vue {
  @Prop(Object) dispensationMedicine!: DispensationMedicine

  medicine!: Medicine
  pending = true

  processText(str: string) {
    return nl2br(sanitize(str))
  }

  handleClickCloseButton() {
    this.$emit('close')
  }

  async created() {
    const { medicineCode } = this.dispensationMedicine
    const res = await this.$api.medicine.fetch({ yjCode: medicineCode })
    if (res.results.length) {
      this.medicine = res.results[0]
    }
    this.pending = false
  }
}
